module.exports = __webpack_public_path__ + "img/map_longueuil.110cb78.png";